/*! roundSlider v1.3.2 | (c) 2015-2018, Soundar | MIT license | http://roundsliderui.com/licence.html */
(function ($, window, undefined) {
    'use strict';
    function RoundSlider(n, t) {
        (this.id = n?.id), (this.control = $(n)), (this.options = $.extend({}, this.defaults, t));
    }
    function CreateRoundSlider(n, t) {
        for (var i, r, u, f = 0; f < this.length; f++)
            if (((i = this[f]), (r = $.data(i, pluginName)), r)) {
                if ($.isPlainObject(n))
                    typeof r.option == 'function'
                        ? r.option(n)
                        : i?.id && window[i?.id] && typeof window[i?.id].option == 'function' && window[i?.id].option(n);
                else if (typeof n == 'string' && typeof r[n] == 'function') {
                    if ((n === 'option' || n.indexOf('get') === 0) && t[2] === undefined) return r[n](t[1]);
                    r[n](t[1], t[2]);
                }
            } else
                (u = new RoundSlider(i, n)),
                    u._saveInstanceOnElement(),
                    u._saveInstanceOnID(),
                    u._raise('beforeCreate') !== !1 ? (u._init(), u._raise('create')) : u._removeData();
        return this;
    }
    var pluginName = 'roundSlider';
    ($.fn[pluginName] = function (n) {
        return CreateRoundSlider.call(this, n, arguments);
    }),
        (RoundSlider.prototype = {
            pluginName: pluginName,
            version: '1.3.2',
            options: {},
            control: null,
            defaults: {
                min: 0,
                max: 100,
                step: 1,
                value: null,
                radius: 85,
                width: 18,
                handleSize: '+0',
                startAngle: 0,
                endAngle: '+360',
                animation: !0,
                showTooltip: !0,
                editableTooltip: !0,
                readOnly: !1,
                disabled: !1,
                keyboardAction: !0,
                mouseScrollAction: !1,
                lineCap: 'square',
                sliderType: 'default',
                circleShape: 'full',
                handleShape: 'round',
                beforeCreate: null,
                create: null,
                start: null,
                drag: null,
                change: null,
                stop: null,
                tooltipFormat: null,
            },
            keys: { UP: 38, DOWN: 40, LEFT: 37, RIGHT: 39 },
            _props: function () {
                return {
                    numberType: ['min', 'max', 'step', 'radius', 'width', 'startAngle'],
                    booleanType: [
                        'animation',
                        'showTooltip',
                        'editableTooltip',
                        'readOnly',
                        'disabled',
                        'keyboardAction',
                        'mouseScrollAction',
                    ],
                    stringType: ['sliderType', 'circleShape', 'handleShape', 'lineCap'],
                };
            },
            _init: function () {
                var t, n;
                (this._isBrowserSupport = this._isBrowserSupported()),
                    (this._isKO = !1),
                    (this._isAngular = !1),
                    this.control.is('input') &&
                        ((this._isInputType = !0),
                        (this._hiddenField = this.control),
                        (this.control = this.$createElement('div')),
                        this.control.insertAfter(this._hiddenField),
                        (this.options.value = this._hiddenField.val() || this.options.value),
                        (t = this),
                        this._checkKO() &&
                            setTimeout(function () {
                                t._checkKO();
                            }, 1),
                        this._checkAngular()),
                    (this._bindOnDrag = !1),
                    (n = this._dataElement().attr('data-updateon')),
                    typeof n == 'string'
                        ? n == 'drag' && (this._bindOnDrag = !0)
                        : this._isAngular && (this._bindOnDrag = !0),
                    this._onInit();
            },
            _onInit: function () {
                this._initialize(), this._update(), this._render();
            },
            _initialize: function () {
                var n = (this.browserName = this.getBrowserName());
                (n && this.control.addClass('rs-' + n), this._isBrowserSupport) &&
                    ((this._isReadOnly = !1), this._checkDataType(), this._refreshCircleShape());
            },
            _render: function () {
                if (
                    ((this.container = this.$createElement('div.rs-container')),
                    (this.innerContainer = this.$createElement('div.rs-inner-container')),
                    (this.block = this.$createElement('div.rs-block rs-outer rs-border')),
                    this.container.append(this.innerContainer.append(this.block)),
                    this.control.addClass('rs-control').empty().append(this.container),
                    this._setRadius(),
                    this._isBrowserSupport)
                )
                    this._createLayers(),
                        this._createColorRanges(),
                        this._setProperties(),
                        this._setValue(),
                        this._updateTooltipPos(),
                        this._bindControlEvents('_bind');
                else {
                    var n = this.$createElement('div.rs-msg');
                    n.html(typeof this._throwError == 'function' ? this._throwError() : this._throwError),
                        this.control.empty().addClass('rs-error').append(n),
                        this._isInputType && this.control.append(this._dataElement());
                }
            },
            _update: function () {
                this._validateSliderType(),
                    this._updateStartEnd(),
                    this._validateStartEnd(),
                    (this._handle1 = this._handle2 = this._handleDefaults()),
                    this._analyzeModelValue(),
                    this._validateModelValue();
            },

            _createLayers: function () {
                var i = this.options.width,
                    t = this._start,
                    n;
                (n = this.$createElement('div.rs-path rs-transition')),
                    this._rangeSlider || this._showRange
                        ? ((this.block1 = n.clone().addClass('rs-range-color').rsRotate(t)),
                          (this.block2 = n.clone().addClass('rs-range-color').css('opacity', '0').rsRotate(t)),
                          (this.block3 = n.clone().addClass('rs-path-color').rsRotate(t)),
                          (this.block4 = n
                              .addClass('rs-path-color')
                              .css({ opacity: '1', 'z-index': '1' })
                              .rsRotate(t - 180)),
                          this.block.append(this.block1, this.block2, this.block3, this.block4).addClass('rs-split'))
                        : this.block.append(n.addClass('rs-path-color')),
                    (this.lastBlock = this.$createElement('span.rs-block').css({ padding: i })),
                    (this.innerBlock = this.$createElement('div.rs-inner rs-bg-color rs-border')),
                    this.lastBlock.append(this.innerBlock),
                    this.block.append(this.lastBlock),
                    this._appendHandle(),
                    this._appendOverlay(),
                    this._appendHiddenField();
            },
            _setProperties: function () {
                this._updatePre(),
                    this._setHandleShape(),
                    this._addAnimation(),
                    this._appendTooltip(),
                    this.options.showTooltip || this._removeTooltip(),
                    this.options.disabled ? this.disable() : this.options.readOnly && this._readOnly(!0),
                    this.options.mouseScrollAction && this._bindScrollEvents('_bind');
            },
            _updatePre: function () {
                this._prechange = this._predrag = this.options.value;
            },
            _setValue: function () {
                if (this._rangeSlider) this._setHandleValue(1), this._setHandleValue(2);
                else {
                    this._showRange && this._setHandleValue(1);
                    var n =
                        this.options.sliderType == 'default'
                            ? this._active || 1
                            : parseFloat(this.bar.children().attr('index'));
                    this._setHandleValue(n);
                }
            },
            _appendAngletip: function () {
                this.container.children('.rs-tooltip').length === 1 &&
                    ((this.angletip = this.$createElement('span.rs-angletip rs-tooltip-text')),
                    this.container.append(this.angletip),
                    this.angletip[0].appendChild(document.createTextNode('n/a')));
            },
            _appendTooltip: function () {
                this.container.children('.rs-tooltip').length === 0 &&
                    ((this.tooltip = this.$createElement('span.rs-tooltip rs-tooltip-text')),
                    this.container.append(this.tooltip),
                    this._tooltipEditable(),
                    this._updateTooltip());
            },
            _removeTooltip: function () {
                this.container.children('.rs-tooltip').length != 0 &&
                    this.tooltip &&
                    this.tooltip.after &&
                    this.tooltip.remove();
            },
            _tooltipEditable: function () {
                if (this.tooltip && this.options.showTooltip) {
                    var n;
                    this.options.editableTooltip
                        ? (this.tooltip.addClass('edit'), (n = '_bind'))
                        : (this.tooltip.removeClass('edit'), (n = '_unbind')),
                        this[n](this.tooltip, 'click', this._editTooltip);
                }
            },
            _editTooltip: function () {
                if (this.tooltip.hasClass('edit') && !this._isReadOnly) {
                    var n = parseFloat(this.tooltip.css('border-left-width')) * 2;
                    (this.input = this.$createElement('input.rs-input rs-tooltip-text').css({
                        height: this.tooltip.outerHeight() - n,
                        width: this.tooltip.outerWidth() - n,
                    })),
                        this.tooltip.html(this.input).removeClass('edit').addClass('hover'),
                        this.input.focus().val(this._getTooltipValue(!0)),
                        this._bind(this.input, 'blur', this._focusOut),
                        this._bind(this.input, 'change', this._focusOut);
                }
            },
            _focusOut: function (n) {
                if (n.type == 'change') {
                    var t = this.input.val().replace('-', ',');
                    t[0] == ',' && (t = '-' + t.slice(1).replace('-', ',')),
                        (this.options.value = t),
                        this._analyzeModelValue(),
                        this._validateModelValue(),
                        this._setValue(),
                        this.input.val(this._getTooltipValue(!0));
                } else this.tooltip.addClass('edit').removeClass('hover'), this._updateTooltip();
                this._raiseEvent('change');
            },
            _createColorRanges: function () {
                var n;
                n = this.$createElement('div.rs-path-two rs-transition');
                this.container.append(n);
            },
            _setHandleShape: function () {
                var n = this.options.handleShape;
                this._handles().removeClass('rs-handle-dot rs-handle-square'),
                    n == 'dot'
                        ? this._handles().addClass('rs-handle-dot')
                        : n == 'square'
                        ? this._handles().addClass('rs-handle-square')
                        : (this.options.handleShape = this.defaults.handleShape);
            },

            _setHandleValue: function (n) {
                this._active = n;
                var t = this['_handle' + n];
                this.options.sliderType != 'min-range' && (this.bar = this._activeHandleBar()),
                    this._changeSliderValue(t.value, t.angle);
            },

            _setAnimation: function () {
                this.options.animation ? this._addAnimation() : this._removeAnimation();
            },
            _addAnimation: function () {
                this.options.animation && this.control.addClass('rs-animation');
            },
            _removeAnimation: function () {
                this.control.removeClass('rs-animation');
            },
            _setRadius: function () {
                var t = this.options.radius,
                    i = t * 2,
                    n = this.options.circleShape,
                    r = i,
                    u = i,
                    f,
                    e;
                if ((this.container.removeClass().addClass('rs-container'), n.indexOf('half') === 0)) {
                    switch (n) {
                        case 'half-top':
                        case 'half-bottom':
                            (r = t), (u = i);
                            break;
                        case 'half-left':
                        case 'half-right':
                            (r = i), (u = t);
                    }
                    this.container.addClass(n.replace('half-', '') + ' half');
                } else
                    n.indexOf('quarter') === 0
                        ? ((r = u = t), (f = n?.split('-')), this.container.addClass(f[0] + ' ' + f[1] + ' ' + f[2]))
                        : this.container.addClass('full ' + n);
                (e = { height: r, width: u }), this.control.css(e), this.container.css(e);
            },
            _border: function (n) {
                return n
                    ? parseFloat(this._startLine.children().css('border-bottom-width'))
                    : parseFloat(this.block.css('border-top-width')) * 2;
            },
            _appendHandle: function () {
                (this._rangeSlider || !this._showRange) && this._createHandle(1) && this._createHandleTwo(1),
                    this._createArc(1),
                    (this._rangeSlider || this._showRange) && this._createHandle(2),
                    (this._startLine = this._addSeperator(this._start, 'rs-start')),
                    (this._endLine = this._addSeperator(this._start + this._end, 'rs-end')),
                    this._refreshSeperator();
            },
            _addSeperator: function (n, t) {
                var r = this.$createElement('span.rs-seperator rs-border'),
                    u = this.options.width,
                    f = this._border(),
                    i = this.$createElement('span.rs-bar rs-transition ' + t)
                        .append(r)
                        .rsRotate(n);
                return this.container.append(i), i;
            },
            _refreshSeperator: function () {
                var i = this._startLine.add(this._endLine),
                    r = i.children().removeAttr('style'),
                    n = this.options,
                    u = n.width,
                    f = this._border(),
                    t = u + f;
                n.lineCap == 'round' && n.circleShape != 'full'
                    ? (i.addClass('rs-rounded'),
                      r.css({ width: t, height: t / 2 + 1 }),
                      this._startLine
                          .children()
                          .css('margin-top', -1)
                          .addClass(n.sliderType == 'min-range' ? 'rs-range-color' : 'rs-path-color'),
                      this._endLine
                          .children()
                          .css('margin-top', t / -2)
                          .addClass('rs-path-color'))
                    : (i.removeClass('rs-rounded'),
                      r
                          .css({ width: t, 'margin-top': this._border(!0) / -2 })
                          .removeClass('rs-range-color rs-path-color'));
            },
            _updateSeperator: function () {
                this._startLine.rsRotate(this._start), this._endLine.rsRotate(this._start + this._end);
            },

            _createHandle: function (n) {
                var t = this.$createElement('div.rs-handle rs-move'),
                    u = this.options,
                    f,
                    r;
                (f = u.handleShape) != 'round' && t.addClass('rs-handle-' + f), t.attr({ index: n, tabIndex: '0' });
                var i = this._dataElement()[0]?.id,
                    i = i ? i + '_' : '',
                    e = i + 'handle' + (u.sliderType == 'range' ? '_' + (n == 1 ? 'start' : 'end') : '');
                return (
                    t.attr({ role: 'slider', 'aria-label': e }),
                    (r = this.$createElement('div.rs-bar rs-transition')
                        .css('z-index', '7')
                        .append(t)
                        .rsRotate(this._start)),
                    r.addClass(u.sliderType == 'range' && n == 2 ? 'rs-second' : 'rs-first'),
                    this.container.append(r),
                    this._refreshHandle(),
                    (this.bar = r),
                    (this._active = n),
                    n != 1 && n != 2 && (this['_handle' + n] = this._handleDefaults()),
                    this._bind(t, 'focus', this._handleFocus),
                    this._bind(t, 'blur', this._handleBlur),
                    t
                );
            },

            _createHandleTwo: function (n) {
                var t = this.$createElement('div.rs-handle-two rs-move'),
                    u = this.options,
                    f,
                    r;
                (f = u.handleShape) != 'round' && t.addClass('rs-handle-square'), t.attr({ index: n, tabIndex: '0' });
                var i = this._dataElement()[0]?.id,
                    i = i ? i + '_' : '',
                    e = i + 'handle' + (u.sliderType == 'range' ? '_' + (n == 1 ? 'start' : 'end') : '');
                return (
                    t.attr({ role: 'slider', 'aria-label': e }),
                    (r = this.$createElement('div.rs-bar rs-transition')
                        .css('z-index', '7')
                        .append(t)
                        .rsRotate(this._start)),
                    r.addClass(u.sliderType == 'range' && n == 2 ? 'rs-second' : 'rs-first'),
                    this.container.append(r),
                    this._refreshHandle(),
                    (this.barthree = r),
                    (this._active = n),
                    n != 1 && n != 2 && (this['_handle' + n] = this._handleDefaults()),
                    this._bind(t, 'focus', this._handleFocus),
                    this._bind(t, 'blur', this._handleBlur),
                    t
                );
            },

            _createArc: function (n) {
                var t = this.$createElement('div.arc rs-move'),
                    u = this.options,
                    f,
                    r;
                (f = u.handleShape) != 'round', t.attr({ index: n, tabIndex: '0' });
                var i = this._dataElement()[0]?.id,
                    i = i ? i + '_' : '',
                    e = i + 'handle' + (u.sliderType == 'range' ? '_' + (n == 1 ? 'start' : 'end') : '');
                var angleTip = document.createElement('P');
                angleTip.appendChild(document.createTextNode('n/a'));
                angleTip.style.transform = 'rotate(-90deg)';
                return (
                    t.attr({ role: 'slider', 'aria-label': e }),
                    (r = this.$createElement('div.rs-bar rs-transition').css('z-index', '4').append(t)),
                    r.addClass(u.sliderType == 'range' && n == 2 ? 'rs-second' : 'rs-first'),
                    r[0].appendChild(angleTip),
                    r.rsRotate(this._start),
                    this.container.append(r),
                    this._refreshHandle(),
                    (this.bartwo = r),
                    (this._active = n),
                    n != 1 && n != 2 && (this['_handle' + n] = this._handleDefaults()),
                    this._bind(t, 'focus', this._handleFocus),
                    this._bind(t, 'blur', this._handleBlur),
                    t
                );
            },

            _refreshHandle: function () {
                var hSize = this.options.handleSize,
                    h,
                    w,
                    isSquare = !0,
                    isNumber = this.isNumber,
                    s,
                    diff;
                if (typeof hSize == 'string' && isNumber(hSize))
                    if (hSize.charAt(0) === '+' || hSize.charAt(0) === '-')
                        try {
                            hSize = eval(this.options.width + hSize.charAt(0) + Math.abs(parseFloat(hSize)));
                        } catch (e) {
                            console.warn(e);
                        }
                    else
                        hSize.indexOf(',') &&
                            ((s = hSize?.split(',')),
                            isNumber(s[0]) &&
                                isNumber(s[1]) &&
                                ((w = parseFloat(s[0])), (h = parseFloat(s[1])), (isSquare = !1)));
                isSquare && (h = w = isNumber(hSize) ? parseFloat(hSize) : this.options.width),
                    (diff = (this.options.width + this._border() - w) / 2),
                    this._handles().css({ height: h, width: w, margin: -h / 2 + 'px 0 0 ' + diff + 'px' });
            },

            _handleDefaults: function () {
                return { angle: this._valueToAngle(this.options.min), value: this.options.min };
            },

            _handles: function () {
                return this.container.children('div.rs-bar').find('.rs-handle');
            },

            _activeHandleBar: function (n) {
                return (n = n != undefined ? n : this._active), $(this.container.children('div.rs-bar')[n - 1]);
            },

            _handleArgs: function (n) {
                n = n != undefined ? n : this._active;
                var t = this['_handle' + n];
                return {
                    element: this._activeHandleBar(n).children(),
                    index: n,
                    isActive: n == this._active,
                    value: t ? t.value : null,
                    angle: t ? t.angle : null,
                };
            },

            _dataElement: function () {
                return this._isInputType ? this._hiddenField : this.control;
            },

            _raiseEvent: function (n) {
                var t = this['_pre' + n];
                if (t !== this.options.value)
                    return (
                        (this['_pre' + n] = this.options.value),
                        this._updateTooltip(),
                        (n == 'change' || (this._bindOnDrag && n == 'drag')) && this._updateHidden(),
                        this._raise(n, { value: this.options.value, preValue: t, handle: this._handleArgs() })
                    );
            },

            _elementDown: function (n) {
                var i, r, u, t, f;
                if (!this._isReadOnly)
                    if (((i = $(n.target)), i.hasClass('rs-handle'))) this._handleDown(n);
                    else {
                        var e = this._getXY(n),
                            o = this._getCenterPoint(),
                            s = this._getDistance(e, o),
                            h = this.block.outerWidth() / 2,
                            c = h - (this.options.width + this._border());
                        s >= c &&
                            s <= h &&
                            (n.preventDefault(),
                            (r = this.control.find('.rs-handle.rs-focus')),
                            this.control.attr('tabindex', '0').focus().removeAttr('tabindex'),
                            i.hasClass('rs-seperator')
                                ? ((t = i.parent().hasClass('rs-start') ? this.options.min : this.options.max),
                                  (u = this._valueToAngle(t)))
                                : ((f = this._getAngleValue(e, o)), (u = f.angle), (t = f.value)),
                            this._rangeSlider &&
                                ((r = this.control.find('.rs-handle.rs-focus')),
                                (this._active =
                                    r.length == 1
                                        ? parseFloat(r.attr('index'))
                                        : this._handle2.value - t < t - this._handle1.value
                                        ? 2
                                        : 1),
                                (this.bar = this._activeHandleBar())),
                            this._changeSliderValue(t, u),
                            this._raiseEvent('change'));
                    }
            },

            _handleDown: function (n) {
                n.preventDefault();
                var t = $(n.target);
                t.focus(),
                    this._removeAnimation(),
                    this._bindMouseEvents('_bind'),
                    (this.bar = t.parent()),
                    (this._active = parseFloat(t.attr('index'))),
                    this._handles().removeClass('rs-move'),
                    this._raise('start', { value: this.options.value, handle: this._handleArgs() });
            },

            _handleMove: function (n) {
                n.preventDefault();
                var u = this._getXY(n),
                    f = this._getCenterPoint(),
                    t = this._getAngleValue(u, f, !0),
                    i,
                    r;
                (i = t.angle), (r = t.value), this._changeSliderValue(r, i), this._raiseEvent('drag');
            },

            _handleUp: function () {
                this._handles().addClass('rs-move'),
                    this._bindMouseEvents('_unbind'),
                    this._addAnimation(),
                    this._raiseEvent('change'),
                    this._raise('stop', { value: this.options.value, handle: this._handleArgs() });
            },
            _handleFocus: function (n) {
                if (!this._isReadOnly) {
                    var t = $(n.target);
                    this._handles().removeClass('rs-focus'),
                        t.addClass('rs-focus'),
                        (this.bar = t.parent()),
                        (this._active = parseFloat(t.attr('index'))),
                        this.options.keyboardAction &&
                            (this._bindKeyboardEvents('_unbind'), this._bindKeyboardEvents('_bind')),
                        this.control.find('div.rs-bar').css('z-index', '7'),
                        this.bar.css('z-index', '8');
                }
            },
            _handleBlur: function () {
                this._handles().removeClass('rs-focus'),
                    this.options.keyboardAction && this._bindKeyboardEvents('_unbind');
            },
            _handleKeyDown: function (n) {
                var t, r, u, i, f;
                this._isReadOnly ||
                    (((t = n.keyCode), (r = this.keys), t == 27 && this._handles().blur(), t >= 35 && t <= 40) &&
                        (t >= 37 && t <= 40 && this._removeAnimation(),
                        (u = this['_handle' + this._active]),
                        n.preventDefault(),
                        t == r.UP || t == r.RIGHT
                            ? (i = this._round(this._limitValue(u.value + this.options.step)))
                            : t == r.DOWN || t == r.LEFT
                            ? (i = this._round(this._limitValue(u.value - this._getMinusStep(u.value))))
                            : t == 36
                            ? (i = this._getKeyValue('Home'))
                            : t == 35 && (i = this._getKeyValue('End')),
                        (f = this._valueToAngle(i)),
                        this._changeSliderValue(i, f),
                        this._raiseEvent('change')));
            },
            _handleKeyUp: function () {
                this._addAnimation();
            },
            _getMinusStep: function (n) {
                if (n == this.options.max) {
                    var t = (this.options.max - this.options.min) % this.options.step;
                    return t == 0 ? this.options.step : t;
                }
                return this.options.step;
            },
            _getKeyValue: function (n) {
                return this._rangeSlider
                    ? n == 'Home'
                        ? this._active == 1
                            ? this.options.min
                            : this._handle1.value
                        : this._active == 1
                        ? this._handle2.value
                        : this.options.max
                    : n == 'Home'
                    ? this.options.min
                    : this.options.max;
            },
            _elementScroll: function (n) {
                if (!this._isReadOnly) {
                    n.preventDefault();
                    var i = n.originalEvent || n,
                        r,
                        t,
                        f,
                        u;
                    ((u = i.wheelDelta ? i.wheelDelta / 60 : i.detail ? -i.detail / 2 : 0), u != 0) &&
                        (this._updateActiveHandle(n),
                        (r = this['_handle' + this._active]),
                        (t = r.value + (u > 0 ? this.options.step : -this._getMinusStep(r.value))),
                        (t = this._limitValue(t)),
                        (f = this._valueToAngle(t)),
                        this._removeAnimation(),
                        this._changeSliderValue(t, f),
                        this._raiseEvent('change'),
                        this._addAnimation());
                }
            },

            _updateActiveHandle: function (n) {
                var t = $(n.target);
                t.hasClass('rs-handle') &&
                    t.parent().parent()[0] == this.control[0] &&
                    ((this.bar = t.parent()), (this._active = parseFloat(t.attr('index')))),
                    this.bar.find('.rs-handle').hasClass('rs-focus') || this.bar.find('.rs-handle').focus();
            },
            _bindControlEvents: function (n) {
                this[n](this.control, 'mousedown', this._elementDown),
                    this[n](this.control, 'touchstart', this._elementDown);
            },
            _bindScrollEvents: function (n) {
                this[n](this.control, 'mousewheel', this._elementScroll),
                    this[n](this.control, 'DOMMouseScroll', this._elementScroll);
            },
            _bindMouseEvents: function (n) {
                this[n]($(document), 'mousemove', this._handleMove),
                    this[n]($(document), 'mouseup', this._handleUp),
                    this[n]($(document), 'mouseleave', this._handleUp),
                    this[n]($(document), 'touchmove', this._handleMove),
                    this[n]($(document), 'touchend', this._handleUp),
                    this[n]($(document), 'touchcancel', this._handleUp);
            },
            _bindKeyboardEvents: function (n) {
                this[n]($(document), 'keydown', this._handleKeyDown), this[n]($(document), 'keyup', this._handleKeyUp);
            },

            _changeSliderValue: function (n, t) {
                var u = this._oriAngle(t),
                    i = this._limitAngle(t);
                if (this._rangeSlider || this._showRange) {
                    if (
                        (this._active == 1 && u <= this._oriAngle(this._handle2.angle)) ||
                        (this._active == 2 && u >= this._oriAngle(this._handle1.angle)) ||
                        this._invertRange
                    ) {
                        (this['_handle' + this._active] = { angle: t, value: n }),
                            (this.options.value = this._rangeSlider
                                ? this._handle1.value + ',' + this._handle2.value
                                : n),
                            this.bar.rsRotate(i),
                            this._updateARIA(n);
                        var r = this._oriAngle(this._handle2.angle) - this._oriAngle(this._handle1.angle),
                            f = '1',
                            e = '0';
                        r <= 180 && !(r < 0 && r > -180) && ((f = '0'), (e = '1')),
                            this.block2.css('opacity', f),
                            this.block3.css('opacity', e),
                            (this._active == 1 ? this.block4 : this.block2).rsRotate(i - 180),
                            (this._active == 1 ? this.block1 : this.block3).rsRotate(i);
                    }
                } else
                    (this['_handle' + this._active] = { angle: t, value: n }),
                        (this.options.value = n),
                        this.bar.rsRotate(i),
                        this.bartwo.rsRotate(i),
                        this.barthree.rsRotate(i),
                        this._updateARIA(n);
            },

            _updateARIA: function (n) {
                var i = this.options.min,
                    r = this.options.max,
                    t;
                this.bar.children().attr({ 'aria-valuenow': n }),
                    this.options.sliderType == 'range'
                        ? ((t = this._handles()),
                          t.eq(0).attr({ 'aria-valuemin': i }),
                          t.eq(1).attr({ 'aria-valuemax': r }),
                          this._active == 1
                              ? t.eq(1).attr({ 'aria-valuemin': n })
                              : t.eq(0).attr({ 'aria-valuemax': n }))
                        : this.bar.children().attr({ 'aria-valuemin': i, 'aria-valuemax': r });
            },

            _checkKO: function () {
                var f = this._dataElement().data('bind'),
                    t,
                    i,
                    r,
                    n,
                    u;
                if (typeof f == 'string' && typeof ko == 'object') {
                    if (((t = ko.dataFor(this._dataElement()[0])), typeof t == 'undefined')) return !0;
                    for (i = f?.split(','), n = 0; n < i.length; n++)
                        if (((u = i[n]?.split(':')), $.trim(u[0]) == 'value')) {
                            r = $.trim(u[1]);
                            break;
                        }
                    r &&
                        ((this._isKO = !0),
                        ko.computed(function () {
                            this.option('value', t[r]());
                        }, this));
                }
            },
            _checkAngular: function () {
                if (
                    typeof angular == 'object' &&
                    typeof angular.element == 'function' &&
                    ((this._ngName = this._dataElement().attr('ng-model')), typeof this._ngName == 'string')
                ) {
                    this._isAngular = !0;
                    var n = this;
                    this._scope().$watch(this._ngName, function (t) {
                        n.option('value', t);
                    });
                }
            },
            _scope: function () {
                return angular.element(this._dataElement()).scope();
            },
            _getDistance: function (n, t) {
                return Math.sqrt((n.x - t.x) * (n.x - t.x) + (n.y - t.y) * (n.y - t.y));
            },
            _getXY: function (n) {
                return (
                    n.type.indexOf('mouse') == -1 && (n = (n.originalEvent || n).changedTouches[0]),
                    { x: n.pageX, y: n.pageY }
                );
            },
            _getCenterPoint: function () {
                var n = this.block.offset();
                return { x: n.left + this.block.outerWidth() / 2, y: n.top + this.block.outerHeight() / 2 };
            },
            _getAngleValue: function (n, t, i) {
                var u = Math.atan2(n.y - t.y, t.x - n.x),
                    r = -u / (Math.PI / 180);
                return r < this._start && (r += 360), (r = this._checkAngle(r, i)), this._processStepByAngle(r);
            },
            _checkAngle: function (n, t) {
                var f = this._oriAngle(n),
                    i = this['_handle' + this._active].angle,
                    r = this._oriAngle(i),
                    u;
                if (f > this._end) {
                    if (!t) return i;
                    n = this._start + (r <= this._end - r ? 0 : this._end);
                } else if (t && ((u = this._handleDragDistance), this.isNumber(u) && Math.abs(f - r) > u)) return i;
                return n;
            },
            _processStepByAngle: function (n) {
                var t = this._angleToValue(n);
                return this._processStepByValue(t);
            },
            _processStepByValue: function (n) {
                var r = this.options.step,
                    e,
                    t,
                    u,
                    f,
                    i,
                    o;
                return (
                    (e = (n - this.options.min) % r),
                    (t = n - e),
                    (u = this._limitValue(t + r)),
                    (f = this._limitValue(t - r)),
                    (i = n >= t ? (n - t < u - n ? t : u) : t - n > n - f ? t : f),
                    (i = this._round(i)),
                    (o = this._valueToAngle(i)),
                    { value: i, angle: o }
                );
            },
            _round: function (n) {
                var t = this.options.step?.toString()?.split('.');
                return n;
            },
            _oriAngle: function (n) {
                var t = n - this._start;
                return t < 0 && (t += 360), t;
            },
            _limitAngle: function (n) {
                return n > 360 + this._start && (n -= 360), n < this._start && (n += 360), n;
            },
            _limitValue: function (n) {
                return (
                    n < this.options.min && (n = this.options.min), n > this.options.max && (n = this.options.max), n
                );
            },
            _angleToValue: function (n) {
                var t = this.options;
                return (this._oriAngle(n) / this._end) * (t.max - t.min) + t.min;
            },
            _valueToAngle: function (n) {
                var t = this.options;
                return ((n - t.min) / (t.max - t.min)) * this._end + this._start;
            },
            _appendHiddenField: function () {
                (this._hiddenField = this._hiddenField || this.$createElement('input')),
                    this._hiddenField.attr({ type: 'hidden', name: this._dataElement()[0]?.id || '' }),
                    this.control.append(this._hiddenField),
                    this._updateHidden();
            },
            _updateHidden: function () {
                var n = this.options.value;
                this._hiddenField.val(n),
                    (this._isKO || this._isAngular) && this._hiddenField.trigger('change'),
                    this._isAngular && (this._scope()[this._ngName] = n);
            },
            _updateTooltip: function () {
                this.tooltip && !this.tooltip.hasClass('hover') && this.tooltip.html(this._getTooltipValue()),
                    this._updateTooltipPos();
                this._updateAngletip();
            },
            _updateAngletip: function () {
                var angleValue = this.options.angle;
                var format = this.options['tooltipFormat'];

                if (!angleValue) {
                    angleValue = '';
                } else if (format) {
                    angleValue = format({ value: angleValue, insideAngle: true });
                }

                this.bartwo[0].childNodes[1].childNodes[0].nodeValue = angleValue;
            },
            _updateTooltipPos: function () {
                this.tooltip && this.tooltip.css(this._getTooltipPos());
            },
            _getTooltipPos: function () {
                var n = this.options.circleShape,
                    t;
                if (n == 'full' || n == 'pie' || n.indexOf('custom') === 0)
                    return {
                        'margin-top': -this.tooltip.outerHeight() / 2 || -10,
                        'margin-left': -this.tooltip.outerWidth() / 2 || -15,
                    };
                if (n.indexOf('half') != -1) {
                    switch (n) {
                        case 'half-top':
                        case 'half-bottom':
                            t = { 'margin-left': -this.tooltip.outerWidth() / 2 };
                            break;
                        case 'half-left':
                        case 'half-right':
                            t = { 'margin-top': -this.tooltip.outerHeight() / 2 };
                    }
                    return t;
                }
                return {};
            },
            _getTooltipValue: function (n) {
                if (this._rangeSlider) {
                    var t = this.options.value?.split(',');
                    return n ? t[0] + ' - ' + t[1] : this._tooltipValue(t[0], 1) + ' - ' + this._tooltipValue(t[1], 2);
                }
                return n ? this.options.value : this._tooltipValue(this.options.value);
            },
            _tooltipValue: function (n, t) {
                var i = this._raise('tooltipFormat', { value: n, handle: this._handleArgs(t) });
                return i != null && typeof i != 'boolean' ? i : n;
            },
            _validateStartAngle: function () {
                var n = this.options.startAngle;
                return (
                    (n = (this.isNumber(n) ? parseFloat(n) : 0) % 360),
                    n < 0 && (n += 360),
                    (this.options.startAngle = n),
                    n
                );
            },
            _validateEndAngle: function () {
                var end = this.options.endAngle;
                if (typeof end == 'string' && this.isNumber(end) && (end.charAt(0) === '+' || end.charAt(0) === '-'))
                    try {
                        end = eval(this.options.startAngle + end.charAt(0) + Math.abs(parseFloat(end)));
                    } catch (e) {
                        console.warn(e);
                    }
                return (
                    (end = (this.isNumber(end) ? parseFloat(end) : 360) % 360),
                    end <= this.options.startAngle && (end += 360),
                    end
                );
            },
            _refreshCircleShape: function () {
                var n = this.options.circleShape,
                    i = [
                        'half-top',
                        'half-bottom',
                        'half-left',
                        'half-right',
                        'quarter-top-left',
                        'quarter-top-right',
                        'quarter-bottom-right',
                        'quarter-bottom-left',
                        'pie',
                        'custom-half',
                        'custom-quarter',
                    ],
                    t;
                i.indexOf(n) == -1 &&
                    ((t = ['h1', 'h2', 'h3', 'h4', 'q1', 'q2', 'q3', 'q4', '3/4', 'ch', 'cq'].indexOf(n)),
                    (n = t != -1 ? i[t] : n == 'half' ? 'half-top' : n == 'quarter' ? 'quarter-top-left' : 'full')),
                    (this.options.circleShape = n);
            },
            _appendOverlay: function () {
                var n = this.options.circleShape;
                n == 'pie'
                    ? this._checkOverlay('.rs-overlay', 270)
                    : (n == 'custom-half' || n == 'custom-quarter') &&
                      (this._checkOverlay('.rs-overlay1', 180),
                      n == 'custom-quarter' && this._checkOverlay('.rs-overlay2', this._end));
            },
            _checkOverlay: function (n, t) {
                var i = this.container.children(n);
                i.length == 0 &&
                    ((i = this.$createElement('div' + n + ' rs-transition rs-bg-color')), this.container.append(i)),
                    i.rsRotate(this._start + t);
            },
            _checkDataType: function () {
                var i = this.options,
                    r,
                    n,
                    t,
                    u = this._props();
                for (r in u.numberType)
                    (n = u.numberType[r]), (t = i[n]), (i[n] = this.isNumber(t) ? parseFloat(t) : this.defaults[n]);
                for (r in u.booleanType) (n = u.booleanType[r]), (t = i[n]), (i[n] = t == 'false' ? !1 : !!t);
                for (r in u.stringType) (n = u.stringType[r]), (t = i[n]), (i[n] = ('' + t).toLowerCase());
            },
            _validateSliderType: function () {
                var n = this.options.sliderType.toLowerCase();
                (this._rangeSlider = this._showRange = !1),
                    n == 'range'
                        ? (this._rangeSlider = this._showRange = !0)
                        : n.indexOf('min') != -1
                        ? ((this._showRange = !0), (n = 'min-range'))
                        : (n = 'default'),
                    (this.options.sliderType = n);
            },
            _updateStartEnd: function () {
                var n = this.options.circleShape;
                n != 'full' &&
                    (n.indexOf('quarter') != -1
                        ? (this.options.endAngle = '+90')
                        : n.indexOf('half') != -1
                        ? (this.options.endAngle = '+180')
                        : n == 'pie' && (this.options.endAngle = '+270'),
                    n == 'quarter-top-left' || n == 'half-top'
                        ? (this.options.startAngle = 0)
                        : n == 'quarter-top-right' || n == 'half-right'
                        ? (this.options.startAngle = 90)
                        : n == 'quarter-bottom-right' || n == 'half-bottom'
                        ? (this.options.startAngle = 180)
                        : (n == 'quarter-bottom-left' || n == 'half-left') && (this.options.startAngle = 270));
            },
            _validateStartEnd: function () {
                (this._start = this._validateStartAngle()), (this._end = this._validateEndAngle());
                var n = this._start < this._end ? 0 : 360;
                this._end += n - this._start;
            },
            _analyzeModelValue: function () {
                var n = this.options.value,
                    t = this.options.min,
                    e = this.options.max,
                    f,
                    u,
                    r = this.isNumber,
                    i;
                n instanceof Array && (n = n?.toString()),
                    (i = typeof n == 'string' ? n?.split(',') : [n]),
                    this._rangeSlider
                        ? (u =
                              typeof n == 'string'
                                  ? i.length >= 2
                                      ? (r(i[0]) ? i[0] : t) + ',' + (r(i[1]) ? i[1] : e)
                                      : r(i[0])
                                      ? t + ',' + i[0]
                                      : t + ',' + t
                                  : r(n)
                                  ? t + ',' + n
                                  : t + ',' + t)
                        : typeof n == 'string'
                        ? ((f = i.pop()), (u = r(f) ? parseFloat(f) : t))
                        : (u = r(n) ? parseFloat(n) : t),
                    (this.options.value = u);
            },
            _validateModelValue: function () {
                var r = this.options.value,
                    i;
                if (this._rangeSlider) {
                    var u = r?.split(','),
                        n = parseFloat(u[0]),
                        t = parseFloat(u[1]);
                    (n = this._limitValue(n)),
                        (t = this._limitValue(t)),
                        this._invertRange || (n > t && (t = n)),
                        (this._handle1 = this._processStepByValue(n)),
                        (this._handle2 = this._processStepByValue(t)),
                        (this.options.value = this._handle1.value + ',' + this._handle2.value);
                } else
                    (i = this._showRange ? 2 : this._active || 1),
                        (this['_handle' + i] = this._processStepByValue(this._limitValue(r))),
                        this._showRange && (this._handle1 = this._handleDefaults()),
                        (this.options.value = this['_handle' + i].value);
            },
            $createElement: function (n) {
                var t = n?.split('.');
                return $(document.createElement(t[0])).addClass(t[1] || '');
            },
            isNumber: function (n) {
                return (n = parseFloat(n)), typeof n == 'number' && !isNaN(n);
            },
            getBrowserName: function () {
                var n = '',
                    t = window.navigator.userAgent;
                return (
                    (!!window.opr && !!opr.addons) || !!window.opera || t.indexOf(' OPR/') >= 0
                        ? (n = 'opera')
                        : typeof InstallTrigger != 'undefined'
                        ? (n = 'firefox')
                        : /*@cc_on!@*/ !1 && !document.documentMode
                        ? window.StyleMedia
                            ? (n = 'edge')
                            : t.indexOf('Safari') != -1 && t.indexOf('Chrome') == -1
                            ? (n = 'safari')
                            : ((!window.chrome || !window.chrome.webstore) && t.indexOf('Chrome') == -1) ||
                              (n = 'chrome')
                        : (n = 'ie'),
                    n
                );
            },
            _isBrowserSupported: function () {
                for (
                    var t = [
                            'borderRadius',
                            'WebkitBorderRadius',
                            'MozBorderRadius',
                            'OBorderRadius',
                            'msBorderRadius',
                            'KhtmlBorderRadius',
                        ],
                        n = 0;
                    n < t.length;
                    n++
                )
                    if (document.body.style[t[n]] !== undefined) return !0;
            },
            _throwError: function () {
                return "This browser doesn't support the border-radious property.";
            },
            _raise: function (n, t) {
                var u = this.options,
                    i = u[n],
                    r = !0;
                return (
                    (t = t || { value: u.value }),
                    (t.id = this?.id),
                    (t.control = this.control),
                    (t.options = u),
                    i &&
                        ((t.type = n),
                        typeof i == 'string' && (i = window[i]),
                        $.isFunction(i) && ((r = i.call(this, t)), (r = r === !1 ? !1 : r))),
                    this.control.trigger($.Event(n, t)),
                    r
                );
            },
            _bind: function (n, t, i) {
                $(n).bind(t, $.proxy(i, this));
            },
            _unbind: function (n, t, i) {
                $(n).unbind(t, $.proxy(i, this));
            },
            _getInstance: function () {
                return $.data(this._dataElement()[0], pluginName);
            },
            _saveInstanceOnElement: function () {
                $.data(this.control[0], pluginName, this);
            },
            _saveInstanceOnID: function () {
                var n = this?.id;
                n && typeof window[n] != 'undefined' && (window[n] = this);
            },
            _removeData: function () {
                var n = this._dataElement()[0];
                $.removeData && $.removeData(n, pluginName),
                    n?.id && typeof window[n?.id]._init == 'function' && delete window[n?.id];
            },
            _destroyControl: function () {
                this._isInputType && this._dataElement().insertAfter(this.control).attr('type', 'text'),
                    this.control.empty().removeClass('rs-control').height('').width(''),
                    this._removeAnimation(),
                    this._bindControlEvents('_unbind');
            },
            _updateWidth: function () {
                this.lastBlock.css('padding', this.options.width), this._refreshHandle();
            },
            _readOnly: function (n) {
                (this._isReadOnly = n),
                    this.container.removeClass('rs-readonly'),
                    n && this.container.addClass('rs-readonly');
            },
            _get: function (n) {
                return this.options[n];
            },
            _set: function (n, t) {
                var i = this._props();
                if ($.inArray(n, i.numberType) != -1) {
                    if (!this.isNumber(t)) return;
                    t = parseFloat(t);
                } else
                    $.inArray(n, i.booleanType) != -1
                        ? (t = t == 'false' ? !1 : !!t)
                        : $.inArray(n, i.stringType) != -1 && (t = t.toLowerCase());
                if (this.options[n] != t) {
                    this.options[n] = t;
                    switch (n) {
                        case 'startAngle':
                        case 'endAngle':
                            this._validateStartEnd(), this._updateSeperator(), this._appendOverlay();
                        case 'min':
                        case 'max':
                        case 'step':
                        case 'value':
                            this._analyzeModelValue(),
                                this._validateModelValue(),
                                this._setValue(),
                                this._updatePre(),
                                this._updateHidden(),
                                this._updateTooltip();
                            break;
                        case 'angle':
                            this._updateAngletip();
                            break;
                        case 'radius':
                            this._setRadius(), this._updateTooltipPos();
                            break;
                        case 'width':
                            this._removeAnimation(),
                                this._updateWidth(),
                                this._updateTooltipPos(),
                                this._addAnimation(),
                                this._refreshSeperator();
                            break;
                        case 'handleSize':
                            this._refreshHandle();
                            break;
                        case 'handleShape':
                            this._setHandleShape();
                            break;
                        case 'animation':
                            this._setAnimation();
                            break;
                        case 'showTooltip':
                            this.options.showTooltip
                                ? (this._appendTooltip(), this._createArc(1))
                                : this._removeTooltip();
                            break;
                        case 'editableTooltip':
                            this._tooltipEditable(), this._updateTooltipPos();
                            break;
                        case 'disabled':
                            this.options.disabled ? this.disable() : this.enable();
                            break;
                        case 'readOnly':
                            this.options.readOnly ? this._readOnly(!0) : !this.options.disabled && this._readOnly(!1);
                            break;
                        case 'mouseScrollAction':
                            this._bindScrollEvents(this.options.mouseScrollAction ? '_bind' : '_unbind');
                            break;
                        case 'lineCap':
                            this._refreshSeperator();
                            break;
                        case 'circleShape':
                            this._refreshCircleShape(),
                                this.options.circleShape == 'full' &&
                                    ((this.options.startAngle = 0), (this.options.endAngle = '+360'));
                        case 'sliderType':
                            this._destroyControl(), this._onInit();
                    }
                    return this;
                }
            },
            option: function (n, t) {
                if (this._getInstance() && this._isBrowserSupport) {
                    if ($.isPlainObject(n)) {
                        (n.min !== undefined || n.max !== undefined) &&
                            (n.min !== undefined && ((this.options.min = n.min), delete n.min),
                            n.max !== undefined && ((this.options.max = n.max), delete n.max),
                            n.value == undefined && this._set('value', this.options.value));
                        for (var i in n) this._set(i, n[i]);
                    } else if (n && typeof n == 'string') {
                        if (t === undefined) return this._get(n);
                        this._set(n, t);
                    }
                    return this;
                }
            },
            getValue: function (n) {
                if (this.options.sliderType == 'range' && this.isNumber(n)) {
                    var t = parseFloat(n);
                    if (t == 1 || t == 2) return this['_handle' + t].value;
                }
                return this._get('value');
            },
            setValue: function (n, t) {
                if (this.isNumber(n)) {
                    if (this.isNumber(t))
                        if (this.options.sliderType == 'range') {
                            var i = parseFloat(t),
                                r = parseFloat(n);
                            i == 1
                                ? (n = r + ',' + this._handle2.value)
                                : i == 2 && (n = this._handle1.value + ',' + r);
                        } else this.options.sliderType == 'default' && (this._active = t);
                    this._set('value', n);
                }
            },
            disable: function () {
                (this.options.disabled = !0), this.container.addClass('rs-disabled'), this._readOnly(!0);
            },
            enable: function () {
                (this.options.disabled = !1),
                    this.container.removeClass('rs-disabled'),
                    this.options.readOnly || this._readOnly(!1);
            },
            destroy: function () {
                this._getInstance() &&
                    (this._destroyControl(), this._removeData(), this._isInputType && this.control.remove());
            },
        }),
        ($.fn.rsRotate = function (n) {
            var t = this;
            return (
                t.css('-webkit-transform', 'rotate(' + n + 'deg)'),
                t.css('-moz-transform', 'rotate(' + n + 'deg)'),
                t.css('-ms-transform', 'rotate(' + n + 'deg)'),
                t.css('-o-transform', 'rotate(' + n + 'deg)'),
                t.css('transform', 'rotate(' + n + 'deg)'),
                t
            );
        }),
        ($.fn[pluginName].prototype = RoundSlider.prototype);
})(jQuery, window);
